// extracted by mini-css-extract-plugin
export default {"tableHeader":"style_tableHeader__XfNJJ","button":"style_button__liHfO","saveButton":"style_saveButton__43-5Q"};